var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MapContainer",style:(`width: ${_vm.width}; height: ${_vm.height}`)},[_c('div',{attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }